<template>
  <div>
    <h4 class="d-inline">Фото</h4>
    <b-button
      variant="outline-primary"
      @click="addPhoto"
      class="ml-3 mb-3 float-right"
    > <em class="fa fa-plus mr-1"></em> Добавить фото</b-button>

    <carousel v-if="carouselImages.length > 0" :style="carouselStyle" class="mt-3"
              :perPageCustom="carouselShowPhotos" ref="refForTrigger"
    >
      <slide v-for="(photo, index) in carouselImages"
             :key="index"
             class="position-relative">
        <img class="carouselPhoto"
             alt="Фото"
             :width='windowWidth > 350 ? 300 : 220'
             :src="photo.source"
             @error="$event.target.src = defaultImage"
        >
        <b-button
          v-b-tooltip.hover
          title="Открыть фото"
          variant="primary"
          @click.capture="showPhoto(photo)"
          class="fa fa-search-plus position-absolute"
          style="top: 3px; left: 212px;"
        ></b-button>
        <b-button
          v-b-tooltip.hover
          title="Удалить фото"
          variant="primary"
          @click="deletePhoto(photo)"
          class="fa fa-times position-absolute"
          style="top: 3px; left: 257px;"
        ></b-button>
      </slide>
    </carousel>
    <b-alert v-else show variant="info" class="mt-3">Фото отсутствует</b-alert>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'

export default {
  name: 'PhotoCarousel',
  components: {
    Carousel,
    Slide
  },
  props: {
    images: {
      type: Array,
      default() {
        return []
      }
    },
    windowWidth: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      carouselStyle: {
        height: '300px',
        width: '100%'
      }
    }
  },
  computed: {
    ...mapGetters({
      content: 'content/getContent'
    }),
    carouselImages() {
      return this.images ? this.images.filter(
        (image) => image.id !== this.content.contentObject.avatar,
      ) : []
    },
    carouselShowPhotos() {
      const defaultVal = [[0, 1], [720, 2]]
      for (let i = 3; i <= this.images.length; i++) {
        defaultVal.push([300 * i + 20 + 100 * i, i])
      }
      return defaultVal
    }
  },
  methods: {
    addPhoto() {
      this.$emit('add')
    },
    showPhoto(photo) {
      this.$emit('show', photo)
    },
    deletePhoto(photo) {
      this.$emit('delete', photo)
    }
  }
}
</script>

<style scoped>

</style>
